import {KeyboardSpecialKeyTypes} from '@toolify/client/src/stores/KeyboardShortcutStore/enum/KeyboardSpecialKeyTypes'

export const KeyboardKeyCodeMap = new Map<string, string>([
  ['ArrowDown', KeyboardSpecialKeyTypes.Down],
  ['ArrowLeft', KeyboardSpecialKeyTypes.Left],
  ['ArrowRight', KeyboardSpecialKeyTypes.Right],
  ['ArrowUp', KeyboardSpecialKeyTypes.Up],
  ['Enter', KeyboardSpecialKeyTypes.Enter],
  ['Escape', KeyboardSpecialKeyTypes.Escape],
  ['Backspace', KeyboardSpecialKeyTypes.Backspace],
  ['Delete', KeyboardSpecialKeyTypes.Delete],
  ['Tab', KeyboardSpecialKeyTypes.Tab],
  ['Space', KeyboardSpecialKeyTypes.Space],
])

const letters = 'abcdefghijklmnoprstuvqwxyz'
for(const letter of letters) {
  KeyboardKeyCodeMap.set(`Key${letter.toUpperCase()}`, letter)
}
